
import locations from '../api/locations'

export const state = {
  locations: [],
  location_pagination_data: {},
  location: ''
}

export const getters = {
  locations: state => state.locations,
  location_pagination_data: state => state.location_pagination_data,
  location: state => state.location
}

export const mutations = {
  ADD_LOCATION (state, data) {
    state.locations.push(data)
  },
  SET_LOCATIONS (state, data) {
    state.locations = data
  },
  SET_LOCATION_PAGINATION (state, data) {
    state.location_pagination_data = data
  },
  SHOW_LOCATION (state, data) {
    state.location = data
  }
}

export const actions = {
  GET_LOCATIONS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      locations.get(data).then(response => {
        if (response.data.data) {
          commit('SET_LOCATIONS', response.data.data)
          let paginationData = {
            from: response.data.from,
            to: response.data.to,
            total: response.data.total,
            last_page: response.data.last_page
          }
          commit('SET_LOCATION_PAGINATION', paginationData)
        } else {
          commit('SET_LOCATIONS', response.data)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_LOCATION ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      locations.create(data).then(response => {
        commit('ADD_LOCATION', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_LOCATION ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      locations.show(id).then(response => {
        commit('SHOW_LOCATION', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_LOCATION ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      locations.update(data, state.location.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_LOCATION ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      locations.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locations.js